import React, { memo } from 'react';


const Hyperlink = memo((props)=>{
	return(
		<></>
	)
});

Hyperlink.defaultProps = {
  generator: false,
  className: "form-control",
}

export default Hyperlink;